import React from 'react';
import { paymentMethodLabel, paymentStatusLabel, PAYMENT_STATUS } from '../services/PaymentMethods';

const TONE_CLASSES = {
  success: 'bg-green-100 text-green-700',
  warning: 'bg-amber-100 text-amber-700',
  danger:  'bg-red-100 text-red-700',
  neutral: 'bg-gray-100 text-gray-600',
};

/**
 * "Venmo · Awaiting confirmation" — the compact payment summary used in
 * participant rosters. Shared so academy and tournament rosters read the same.
 *
 * The method is optional. An entry can owe money before anyone has chosen how
 * to pay it — one created for a non-paying role and later upgraded, or one
 * predating payment support — and showing an amount with no status at all
 * reads as though nothing is outstanding.
 *
 * Renders nothing only when there is genuinely nothing to say: no method and
 * no amount owed, which is what a free entry looks like.
 */
export default function PaymentStatusBadge({ method, status, amountDue, className = '' }) {
  const owesSomething = Number(amountDue ?? 0) > 0;
  if (!method && !owesSomething) return null;

  const tone = PAYMENT_STATUS[status]?.tone || 'neutral';

  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      {method && (
        <span className="text-[11px] text-gray-500">{paymentMethodLabel(method)}</span>
      )}
      <span className={`px-1.5 py-0.5 rounded text-[10px] font-semibold ${TONE_CLASSES[tone]}`}>
        {paymentStatusLabel(status)}
      </span>
    </span>
  );
}
